module.exports = __webpack_public_path__ + "static/media/angela_tan.8cc9ef21.png";